/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Rolepermissions1Inputs */

const en_entity_rolepermissions1 = /** @type {(inputs: Entity_Rolepermissions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Permissions`)
};

const de_entity_rolepermissions1 = /** @type {(inputs: Entity_Rolepermissions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollenberechtigungen`)
};

/**
* | output |
* | --- |
* | "Role Permissions" |
*
* @param {Entity_Rolepermissions1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_rolepermissions1 = /** @type {((inputs?: Entity_Rolepermissions1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Rolepermissions1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_rolepermissions1(inputs)
	return de_entity_rolepermissions1(inputs)
});
export { entity_rolepermissions1 as "entity_rolePermissions" }